/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Mobile PDP thumbnail A/B lives in mobile-thumbnail-ab-test.js
   (body[data-mobile-thumbnail="true|false"]). */

/**
 * Accordion toggle (How To Care / Shipping Info / Money Back Guarantee, etc.)
 *
 * The theme renders accordion blocks via snippets/selluxe-accordion.liquid and
 * styles the open/closed states via .accordion.active in selluxe-custom.css,
 * but no JS was wired up to toggle that class. This adds the missing click
 * handler. Event delegation is used so it also covers accordions injected
 * after page load (variant swap, sections rendered via section rendering API,
 * etc.).
 */
(function () {
  'use strict';

  function toggleAccordion(accordion) {
    var content = accordion.querySelector(':scope > .accordion-content');
    var isActive = accordion.classList.contains('active');

    if (isActive) {
      // Collapsing: lock current height, then transition to 0 next frame.
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          accordion.classList.remove('active');
          content.style.maxHeight = '0px';
        });
      } else {
        accordion.classList.remove('active');
      }
    } else {
      accordion.classList.add('active');
      if (content) {
        // Use scrollHeight so the CSS max-height transition animates smoothly.
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var header = event.target.closest('.accordion > .accordion-header');
    if (!header) return;
    var accordion = header.parentElement;
    if (!accordion || !accordion.classList.contains('accordion')) return;
    toggleAccordion(accordion);
  });

  // Make headers feel like buttons for keyboard / screen-reader users.
  function decorateHeaders(root) {
    var headers = (root || document).querySelectorAll('.accordion > .accordion-header');
    headers.forEach(function (h) {
      if (h.getAttribute('role') !== 'button') h.setAttribute('role', 'button');
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '0');
    });
  }

  // Keyboard support: Enter / Space toggles the focused header.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var header = event.target.closest && event.target.closest('.accordion > .accordion-header');
    if (!header) return;
    event.preventDefault();
    toggleAccordion(header.parentElement);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { decorateHeaders(); });
  } else {
    decorateHeaders();
  }

  // Re-decorate after Shopify section re-renders (e.g., variant change).
  document.addEventListener('shopify:section:load', function (e) {
    decorateHeaders(e.target);
  });
})();